import StructuredData from './StructuredData';

interface OrganizationSchemaProps {
  name?: string;
  url?: string;
  logo?: string;
  description?: string;
  email?: string;
  phone?: string;
  address?: {
    streetAddress?: string;
    addressLocality?: string;
    addressRegion?: string;
    postalCode?: string;
    addressCountry?: string;
  };
  sameAs?: string[]; // Social media profiles
}

const OrganizationSchema: React.FC<OrganizationSchemaProps> = ({
  name = 'EPEN Ltd.',
  url = 'https://vxfx.io',
  logo = 'https://vxfx.io/epenfav.webp',
  description = 'EPEN Ltd. is a software company that develops video plugin development frameworks for Adobe Premiere and DaVinci Resolve.',
  email,
  phone,
  address,
  sameAs = [],
}) => {
  const siteUrl = process.env.SITE_URL || 'https://vxfx.io';

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name,
    url: url || siteUrl,
    logo: logo || `${siteUrl}/epenfav.webp`,
    description,
    ...(email && { email }),
    ...(phone && { telephone: phone }),
    ...(address && {
      address: {
        '@type': 'PostalAddress',
        ...(address.streetAddress && { streetAddress: address.streetAddress }),
        ...(address.addressLocality && { addressLocality: address.addressLocality }),
        ...(address.addressRegion && { addressRegion: address.addressRegion }),
        ...(address.postalCode && { postalCode: address.postalCode }),
        ...(address.addressCountry && { addressCountry: address.addressCountry }),
      },
    }),
    ...(sameAs.length > 0 && { sameAs }),
  };

  return <StructuredData data={organizationSchema} />;
};

export default OrganizationSchema;
